"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo(props) {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, props, "Checkbox"), /*#__PURE__*/_react.default.createElement(_antd.Checkbox, (0, _extends2.default)({}, props, {
    checked: true
  }), "\u9009\u4E2D\u6001"));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary', 'colorText', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;